export const getLastnYear = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2022;
  let years = [];

  for (let year = startYear; year <= currentYear; year++) {
    // years.push(year);
    years = [year, ...years];
  }

  return years;
};

export const toBnNumber = (enNum) => {
  const nums = { 0: '০', 1: '১', 2: '২', 3: '৩', 4: '৪', 5: '৫', 6: '৬', 7: '৭', 8: '৮', 9: '৯' };
  return enNum.toString().replace(/[0123456789]/g, (m) => nums[m]);
};

/** Height inches must stay in the 0–11 range (12 in = 1 extra ft). */
export const normalizeInchInput = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const digits = String(value).replace(/[^\d]/g, '');
  if (digits === '') return '';
  const num = Number(digits);
  if (Number.isNaN(num)) return '';
  return String(Math.min(11, Math.max(0, num)));
};

const daysInMonth = function (m, y) {
  switch (m) {
    case 1:
      return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
    case 8:
    case 3:
    case 5:
    case 10:
      return 30;
    default:
      return 31;
  }
};

export const isValidDate = function (d, m, y) {
  m = parseInt(m, 10) - 1;
  return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
};

export const getErrors = function (error) {
  let errorArray = [];

  for (const key in error) {
    errorArray.push({ name: key, value: error[key][0] });
  }

  return errorArray;
};

export function dateRange(type) {
  const year = new Date().getFullYear();
  if (type === 'min') {
    return `${year}-01-01`;
  } else {
    return `${year}-12-31`;
  }
}

// Client-side student search on an already-loaded list (name, roll, or student id)
export const matchesStudentSearch = (student, query) => {
  const q = query == null ? '' : String(query).trim().toLowerCase();
  if (!q) return true;
  if (!student) return false;
  const fields = [student.name, student.roll, student.id, student.student_id, student.progress_id];
  return fields.some((field) => field != null && String(field).toLowerCase().includes(q));
};

export const filterStudentsByQuery = (list, query) => {
  if (!Array.isArray(list)) return [];
  return list.filter((student) => matchesStudentSearch(student, query));
};

// Empty / "all" / "0" mean the same thing on report filters: do not send a specific value
export const isAllFilterValue = (value) => {
  if (value === null || value === undefined) return true;
  const v = String(value).trim().toLowerCase();
  return v === '' || v === 'all' || v === '0';
};

export const stripAllFilterValues = (dataInfo) => {
  const params = { ...(dataInfo || {}) };
  Object.keys(params).forEach((key) => {
    if (isAllFilterValue(params[key])) {
      delete params[key];
    }
  });
  return params;
};

export const reportSliceByProgram = (report, programName) => {
  const rows = Array.isArray(report?.data) ? report.data : [];
  const data = rows.filter((item) => item?.program === programName || item?.others?.program === programName);
  return { ...report, data };
};

// Display-only: empty response fields (not 0 — 0 is valid)
export const isMissingMetric = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && value.trim() === '') return true;
  return false;
};

export const isOddPercent = (value) => {
  if (isMissingMetric(value)) return false;
  const n = Number(String(value).replace('%', ''));
  return Number.isFinite(n) && (n < 0 || n > 100);
};

export const isOddCount = (value) => {
  if (isMissingMetric(value)) return false;
  const n = Number(value);
  return Number.isFinite(n) && n < 0;
};

export const formatMetricDisplay = (value) => {
  if (isMissingMetric(value)) return '—';
  return String(value);
};
